/**
 * STAGE 2 深海·水压 —— 慢速大弹 + 涡旋弹。
 * 小兵射型：大弹单狙（fish）/ 大弹 3 路（goldfish）/ 曲线狙（eel）/ 慢环 + 大弹狙（shark）。
 */
import * as P from '../../game/patterns.js';
import { aimOf, fireTimer, curveBullet, s2Mid, s2Big } from './bosses.js';

const DROP_STD = [{ type: 'P', weight: 2 }, { type: 'POINT', weight: 3 }]; // P 占比 40%
const DROP_POINT = [{ type: 'POINT', weight: 1 }];
const DROP_ELITE = [{ type: 'B', weight: 1 }, { type: 'STAR', weight: 1 }, { type: 'P', weight: 2 }]; // 精英必掉半数为 P

/** 小鱼：直线 + 慢速大弹单狙 */
function fish(x, y, vx, vy) {
  return {
    x, y, hp: 8, r: 12, spriteKey: 's2_fish', scoreValue: 150, drops: DROP_STD,
    script(e, dt, ctx) {
      e.x += vx * dt * 60;
      e.y += vy * dt * 60;
      if (e.y > 8 && e.y < 340 && fireTimer(e, dt, 2.0)) {
        P.aimed(ctx.field, e.x, e.y, e.age, aimOf(ctx, e.x, e.y), { n: 1, speed: 1.4, r: 7, color: 'orb_cyan', onUpdate: curveBullet(0.3) });
      }
    },
  };
}

/** 金鱼：正弦 + 慢速大弹 3 路 */
function goldfish(x, y, vy) {
  return {
    x, y, hp: 10, r: 11, spriteKey: 's2_goldfish', scoreValue: 200, drops: DROP_POINT,
    script(e, dt, ctx) {
      e.x += Math.sin(e.age * 1.8) * 0.7 * dt * 60;
      e.y += vy * dt * 60;
      if (e.y > 8 && e.y < 340 && fireTimer(e, dt, 2.4)) {
        P.spread(ctx.field, e.x, e.y, e.age, aimOf(ctx, e.x, e.y), { n: 3, arc: 0.6, speed: 1.3, r: 6, color: 'orb_orange', onUpdate: curveBullet(0.3) });
      }
    },
  };
}

/** 鳗鱼：快速斜插 + 曲线狙 */
function eel(x, y, vx, vy) {
  return {
    x, y, hp: 14, r: 12, spriteKey: 's2_eel', scoreValue: 300, drops: DROP_STD,
    script(e, dt, ctx) {
      e.x += vx * dt * 60;
      e.y += vy * dt * 60;
      if (e.y > 8 && e.y < 360 && fireTimer(e, dt, 1.6)) {
        const a = aimOf(ctx, e.x, e.y);
        ctx.field.spawn({ x: e.x, y: e.y, speed: 1.8, angle: a, r: 4, color: 'drop_blue', onUpdate: curveBullet(vx > 0 ? -1.5 : 1.5) });
      }
    },
  };
}

/** 鲨鱼精英：悬停慢环 + 大弹 3 连狙 */
function shark(x) {
  return {
    x, y: -28, hp: 22, r: 16, spriteKey: 's2_shark', scoreValue: 400, drops: DROP_ELITE,
    script(e, dt, ctx) {
      if (e.y < 140) {
        e.y += 1.5 * dt * 60;
      } else if ((e._hold = (e._hold || 0) + dt) < 3.5) {
        e.x += Math.sin(e.age * 1.2) * 0.6 * dt * 60;
        if (fireTimer(e, dt, 1.8)) {
          P.ring(ctx.field, e.x, e.y, e.age, 0, { n: 8, speed: 1.1, r: 6, offset: e.age, color: 'orb_cyan', onUpdate: curveBullet(0.3) });
        }
        if (fireTimer(e, dt, 1.3, '_ft2')) {
          P.aimed(ctx.field, e.x, e.y, e.age, aimOf(ctx, e.x, e.y), { n: 3, speed: 1.5, r: 7, color: 'orb_orange', onUpdate: curveBullet(0.3) });
        }
      } else {
        e.y += 2.0 * dt * 60;
      }
    },
  };
}

export default {
  id: 2, name: '深海·水压', bg: 'bg2', bgm: 'stage2',
  *script(api) {
    const W = api.VIEW_W;
    yield { say: 'STAGE 2  深海·水压' };
    yield { wait: 1.0 };

    // W1 双纵队
    yield {
      wave: [
        ...[0, 1, 2].map((i) => fish(150, -24 - i * 48, 0, 1.4)),
        ...[0, 1, 2].map((i) => fish(W - 150, -48 - i * 48, 0, 1.4)),
      ],
    };
    yield { wait: 4.5 };
    // W2 金鱼横排正弦
    yield { wave: [0, 1, 2, 3].map((i) => goldfish(80 + i * 105, -24, 1.0)) };
    yield { wait: 4.5 };
    // W3 鳗鱼交叉
    yield {
      wave: [
        ...[0, 1].map((i) => eel(60 + i * 50, -24 - i * 40, 1.1, 2.2)),
        ...[0, 1].map((i) => eel(W - 60 - i * 50, -24 - i * 40, -1.1, 2.2)),
      ],
    };
    yield { wait: 4.0 };
    // W4 精英鲨鱼
    yield { wave: [shark(W / 2)] };
    yield { clear: true };
    yield { wait: 1.0 };

    yield { boss: s2Mid() };
    yield { wait: 2.0 };

    // W5 包夹：两侧慢速大弹压场（道中二，强度上升）
    yield {
      wave: [
        ...[0, 1, 2].map((i) => fish(-20, 90 + i * 44, 1.3, 0.5)),
        ...[0, 1, 2].map((i) => fish(W + 20, 110 + i * 44, -1.3, 0.5)),
      ],
    };
    yield { wait: 4.5 };
    // W6 鳗鱼 + 金鱼混编
    yield {
      wave: [
        ...[0, 1, 2].map((i) => goldfish(90 + i * 150, -24, 1.2)),
        ...[0, 1].map((i) => eel(80 + i * 40, -60, 1.2, 2.4)),
        ...[0, 1].map((i) => eel(W - 80 - i * 40, -60, -1.2, 2.4)),
      ],
    };
    yield { wait: 4.0 };
    // W7 双鲨鱼
    yield { wave: [shark(140), shark(W - 140)] };
    yield { clear: true };
    yield { wait: 1.0 };

    yield { boss: s2Big() };
    yield { say: 'STAGE 2 CLEAR' };
  },
};
